import React from 'react'
import ParticipantOverviewStatsCard from './ParticipantOverviewStatsCard'
import ParticipantManagementTable from './ParticipantManagementTable'

const ParticipantManagementTab = () => {
    return (
        <div className='space-y-6 py-3'>
            <ParticipantOverviewStatsCard />

            <ParticipantManagementTable />
        </div>
    )
}

export default ParticipantManagementTab